import { Component, Input, OnInit } from '@angular/core';
import { PaymentService, PaymentV2Service, PortfolioService, UtilService, VariablesService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-quickdonate-card',
  templateUrl: './quickdonate-card.component.html',
  styleUrls: ['./quickdonate-card.component.scss']
})
export class QuickdonateCardComponent implements OnInit {
  recentPaymodes = [];
  orders = [];
  @Input() currency;
  isMobile: any;
  user;

  constructor(
    public vars: VariablesService,
    public vwo: VwoService,
    public utilService: UtilService,
    public paymentService: PaymentService,
    private portfolioService: PortfolioService,
    public paymentV2: PaymentV2Service
  ) { }

  ngOnInit(): void {
    this.isMobile = this.utilService.isMobile();
    this.vars.userData.subscribe(res => {
      this.user = res;
    })
    if (this.user?.lastorder) {
      this.getPaymentOptionsforQD(this.currency);
    }
  }

  getPaymentOptionsforQD(currency) {
    let params = `&mobile_no=${this.user?.phone_1}&is_mobile=${this.utilService.isMobile() ? 1 : 0}&amount=${this.user?.lastorder?.donated_amount_local}`;
    this.paymentService.getPaymentOptions(currency, params).subscribe((res: any) => {
      if (res?.data?.options?.PREVIOUSPAYMENTGATEWAY) {
        this.recentPaymodes[0] = Object.values(res?.data?.options?.PREVIOUSPAYMENTGATEWAY)[0];
        this.recentPaymodes[1] = Object.values(res?.data?.options?.PREVIOUSPAYMENTGATEWAY)[1] || Object.values(res.data.options.PREVIOUSPAYMENTGATEWAY)[0];
      } else {
        this.recentPaymodes[0] = null;
        this.recentPaymodes[1] = null;
      }
    });
    this.getBeneficiaries();
  }

  getBeneficiaries() {
    const qparam = `?with=campaign;campaign.beneficiary;campaign.beneficiaryname;campaign.mediaBeneficiary;campaign.campaigner.avtar;campaign.updatesCount;campaign.basicinfo;campaign.hospital;`
      .concat(`campaign.viewmedicalbill;campaign.leaderboard;campaign.theater;campaign.storyTitle;campaign.storyDescription&limit=200&orderBy=creation_date&sortedBy=desc`);
    this.portfolioService.getBeneficiaries(qparam).subscribe((res: any) => {
      this.orders[0] = res.data.data[0];
      this.orders[1] = res.data.data[1] || '';
      this.orders = this.orders.filter(elm => elm);
    });
  }

}
